import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type {
  CarePlan,
  RequestGroup,
  ServiceRequest,
} from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface CancelOrderResponse {
  requestGroup: RequestGroup;
  serviceRequests: ServiceRequest[];
  carePlan: CarePlan;
}

export const useCancelOrder = ({
  patientId,
  encounterId,
  requestGroupId,
}: {
  patientId: string;
  encounterId: string;
  requestGroupId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CancelOrderResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Labs.CANCEL_ORDER({
        patientId,
        encounterId,
        requestGroupId,
      }),
      mutationFn: async () => {
        return axiosInstance.post(`/labs/order/v2/${requestGroupId}/cancel`);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT_V2({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
